/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import is from 'is_js';
// $FlowFixMe
import BigNumber from 'bignumber.js';

import type { Curreny } from '../reducers/exchange';
import type { UserConfig } from '../reducers/users';
import { DASH, formatNumber } from '../utils/number';

const USD = 'USD';
const ACCURANCY_DECIMAL = 6;
const GROSS_DECIMAL = 2;

const mapStateToProps = ({
  locale, currencyList, fiatRate, userPreferredCurrency,
}) => ({
  locale,
  currencyList,
  fiatRate,
  preferredCurrency: userPreferredCurrency,
});

type FiatPriceProps = {
  prefix?: string,
  locale: string,
  currencyList: Curreny[],
  fiatRateWithCurrency?: Object,
  fiatRate: Object,
  quoteAsset: string,
  precision?: number,
  preferredCurrency?: string,
  price: string,
  preferredCurrency?: UserConfig,
  color?: string,
};

type ComponentProps = {
  prefix: string,
  locale: string,
  fiatRate: Object,
  fiatRateWithCurrency?: Object,
  quoteAsset: string,
  precision?: number,
  price: string,
  color?: string,
  currencyList?: Curreny[],
  preferredCurrency?: UserConfig,
};

type ShowData = {
  prefixStr: string,
  symbol: string,
  calculatedprice: string,
  unit: string,
};

export default
@connect(mapStateToProps)
class StyledFiatPrice extends React.Component<ComponentProps> {
  static defaultProps = {
    prefix: '',
    locale: 'en',
    fiatRate: {},
    precision: 2,
    currencyList: [],
    color: undefined,
    preferredCurrency: undefined,
  };

  render() {
    return null;
  }
}
export const getFiatPrice = (props: Object): ShowData | null => {
  const {
    currencyList, price, quoteAsset, prefix, fiatRate,
  } = props;

  const currency = (currencyList && currencyList.find(c => c.name === USD));
  if (is.undefined(fiatRate) || is.undefined(fiatRate[quoteAsset]) || is.undefined(price)) {
    return null;
  }
  const prefixStr = is.undefined(prefix) ? '' : prefix || '';
  const sum = BigNumber(price).multipliedBy(BigNumber(fiatRate[quoteAsset])).toFixed(ACCURANCY_DECIMAL); // TODO

  const calculatedprice = formatNumber(sum, GROSS_DECIMAL);
  const symbol = currency ? currency.symbol : '$';
  const unit = currency ? currency.name : 'USD';

  return {
    prefixStr,
    symbol,
    calculatedprice,
    fiatPrice: sum,
    unit,
  };
};

export const FiatPrice = (props: FiatPriceProps) => {
  const data = getFiatPrice(props);
  if (data === null) {
    return <span>{DASH}</span>;
  }
  const { prefixStr, symbol, calculatedprice } = data;
  return (
    <span style={{ color: props.color, fontSize: 12 }}>
      {prefixStr}
      {symbol}
      {calculatedprice}
    </span>
  );
};

export const FiatPriceWithUnit = () => null;
FiatPrice.defaultProps = {
  prefix: '',
  precision: 2,
  preferredCurrency: undefined,
};
FiatPriceWithUnit.defaultProps = {
  prefix: '',
  precision: 2,
  preferredCurrency: undefined,
};
